import { ChangeEvent, useEffect, useState } from 'react';
import styles from './styles/Scoreboard.module.scss';
import { Dayjs } from 'dayjs';
import cn from 'classnames';

const getDateArray = (date: Dayjs) => [
  date.clone().subtract(3, 'days'),
  date.clone().subtract(2, 'days'),
  date.clone().subtract(1, 'days'),
  date.clone(),
  date.clone().add(1, 'days'),
  date.clone().add(2, 'days'),
  date.clone().add(3, 'days')
];

const MonthSelector = ({ value, onChange }: { value: number; onChange: (e: ChangeEvent<HTMLSelectElement>) => void }) => (
  <select onChange={onChange} value={value}>
    <option value="0">January</option>
    <option value="1">February</option>
    <option value="2">March</option>
    <option value="3">April</option>
    <option value="4">May</option>
    <option value="5">June</option>
    <option value="6">July</option>
    <option value="7">August</option>
    <option value="8">September</option>
    <option value="9">October</option>
    <option value="10">November</option>
    <option value="11">December</option>
  </select>
);

interface DatePickProps {
  date: Dayjs;
  isCurrentDate: boolean;
  handleChange: (d: Dayjs) => void;
}

const DatePick = ({ date, isCurrentDate, handleChange }: DatePickProps) => (
  <div onClick={() => handleChange(date)} className={isCurrentDate ? `${styles.DatePick} ${styles.CurrentDate}` : styles.DatePick}>
    <div>{date.format('ddd')}</div>
    <div>{date.format('DD')}</div>
  </div>
);

interface DatepickerProps {
  value: Dayjs;
  handleChange: (d: Dayjs) => void;
}

const Datepicker = ({ value, handleChange }: DatepickerProps) => {
  const [currentDate, setCurrentDate] = useState(value);
  const [selectedMonth, setSelectedMonth] = useState(value.month());
  const [selectedYear, setSelectedYear] = useState(value.year());
  const currentYear = value.year();

  const dateArray = getDateArray(currentDate);

  useEffect(() => {
    if (currentDate.month() !== selectedMonth) setSelectedMonth(currentDate.month());
  }, [currentDate]);
  useEffect(() => setCurrentDate(currentDate.clone().month(selectedMonth)), [selectedMonth]);
  useEffect(() => setCurrentDate(currentDate.clone().year(selectedYear)), [selectedYear]);

  return (
    <div className={styles.DatepickerContainer}>
      <div className={styles.SBLWidgetDatepicker}>
        <div className={styles.DatepickerSelectors}>
          <MonthSelector onChange={e => setSelectedMonth(+e.target.value)} value={selectedMonth} />
          <select value={selectedYear} onChange={e => setSelectedYear(parseInt(e.target.value))}>
            <option value={+currentYear - 1}>{+currentYear - 1}</option>
            <option value={+currentYear}>{+currentYear}</option>
            <option value={+currentYear + 1}>{+currentYear + 1}</option>
          </select>
        </div>
        <div className={styles.DatepickerDays}>
          <div onClick={() => setCurrentDate(currentDate.clone().subtract(7, 'days'))} className={styles.DatepickerArrow} />
          {dateArray.map(date => (
            <DatePick key={date.toString()} date={date} isCurrentDate={date.isSame(value)} handleChange={handleChange} />
          ))}
          <div
            onClick={() => setCurrentDate(currentDate.clone().add(7, 'days'))}
            className={cn(styles.DatepickerArrow, styles.DatepickerRightArrow)}
          />
        </div>
      </div>
      <div className={styles.DatepickerBackground} />
    </div>
  );
};

export default Datepicker;
